import { Main } from '../../../../components/Main';

export const DeliveryMaterials = () => {
  return (
    <Main title="Entrega de Materiais">
      <h1>Pagina de entrega de materias</h1>
    </Main>
  );
};
